(() => {
	const openModal = (modal, src, type) => {
		if (!modal || !src) return;
		const modalVideo = modal.querySelector("video");
		if (!modalVideo) return;
		modalVideo.innerHTML = "";
		const source = document.createElement("source");
		source.src = src;
		if (type) source.type = type;
		modalVideo.appendChild(source);
		modalVideo.load();
		modal.hidden = false;
		document.body.style.overflow = "hidden";
		const result = modalVideo.play();
		if (result && typeof result.catch === "function") result.catch(() => {});
	};

	const closeModal = (modal) => {
		if (!modal) return;
		const modalVideo = modal.querySelector("video");
		if (modalVideo) {
			modalVideo.pause();
			modalVideo.removeAttribute("src");
			modalVideo.innerHTML = "";
			modalVideo.load();
		}
		modal.hidden = true;
		document.body.style.overflow = "";
	};

	const handleButtonClick = (button, event) => {
		event.preventDefault();
		event.stopPropagation();
		const item = button.closest(".categories-list__item");
		const section = button.closest(".categories-list");
		if (!item || !section) return;

		const slot = item.querySelector(".categories-list__video");
		if (!slot) return;

		const modal = section.querySelector("[data-categories-list-modal]");
		openModal(modal, slot.dataset.videoSrc, slot.dataset.videoType);
	};

	if (!document.documentElement.dataset.categoriesListBound) {
		document.documentElement.dataset.categoriesListBound = "1";

		document.addEventListener("click", (event) => {
			const closeTarget = event.target.closest("[data-modal-close]");
			if (closeTarget) {
				const modal = closeTarget.closest("[data-categories-list-modal]");
				closeModal(modal);
				return;
			}
			const button = event.target.closest(".categories-list__video-play-button");
			if (button) handleButtonClick(button, event);
		});

		document.addEventListener("keydown", (event) => {
			if (event.key !== "Escape") return;
			document
				.querySelectorAll("[data-categories-list-modal]:not([hidden])")
				.forEach((modal) => closeModal(modal));
		});
	}

	const initSection = (section) => {
		const items = section.querySelectorAll(".categories-list__item-inner");
		items.forEach((inner) => {
			if (inner.dataset.hoverBound) return;
			inner.dataset.hoverBound = "1";
			inner.addEventListener("mouseover", () => {
				if (section.getBoundingClientRect().width <= 1200) return;
				inner.classList.remove(inner.dataset.base);
				inner.classList.add(inner.dataset.hover);
			});
			inner.addEventListener("mouseout", () => {
				if (section.getBoundingClientRect().width <= 1200) return;
				inner.classList.remove(inner.dataset.hover);
				inner.classList.add(inner.dataset.base);
			});
		});
	};

	const init = () => {
		document
			.querySelectorAll(".categories-list")
			.forEach((section) => initSection(section));
	};

	init();
	document.addEventListener("shopify:section:load", init);
})();
